import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ModalComponent } from '@app/core/services/modal-manager/modal-component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CertRequirementsService } from './cert-requirements.service';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { SharedModule } from '@app/shared/shared.module';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';
import { ModalManagerService, ModalTypes } from '@app/core/services/modal-manager';
import { DiplomaService } from '../diploma/diploma.service';
import { NotificationsService } from '@app/core/services/notifications/notifications.service';
import { RolesService } from '@app/core/services';
import { MembershipService } from '@app/core/services/membership/membership.service';

@Component({
  standalone: true,
  imports: [CommonModule, TranslateModule, PipesModule, SharedModule, LocalizeRouterModule, RouterModule],
  selector: 'cert-requirements',
  templateUrl: './cert-requirements.component.html',
  styleUrls: ['./cert-requirements.component.scss'],
})
export class CertRequirementsComponent extends ModalComponent {
  service = inject(CertRequirementsService);
  diplomaService = inject(DiplomaService);
  modalManagerService = inject(ModalManagerService);
  notificationsService = inject(NotificationsService);
  translateService = inject(TranslateService);
  rolesService = inject(RolesService);
  membershipService = inject(MembershipService);
  downloadingUserDiploma = false;

  trainingLevels() {
    return this.service.cert?.training_levels.map((l) => l.title).join(', ');
  }

  openFeedback() {
    let url = `/certifications/${this.service.cert?.id}/`;
    if (this.service.cert?.type === 'instructor_certification') {
      url += 'pro-';
    }
    url += 'feedback';
    this.navDataService.navigate(url);
    this.dismiss();
  }

  downloadCert() {
    const cert = this.service.cert;
    if (cert?.status !== 'passed' || this.downloadingUserDiploma) {
      return;
    }

    if (this.rolesService.isExpired) {
      this.membershipService.tryToRenew().subscribe();
      return;
    }

    this.downloadingUserDiploma = true;
    this.modalManagerService
      .open(ModalTypes.diploma, {
        id: cert.id,
        certification_date: cert.certification_date,
        training_level: [...cert.training_levels].pop()?.title ?? '',
      })
      .subscribe({
        next: () => {
          this.downloadingUserDiploma = false;
        },
        error: () => {
          this.notificationsService.notifyError(
            this.translateService.instant('An error occurred when generating your diploma')
          );
          this.downloadingUserDiploma = false;
        },
      });
  }
}
